<script setup>
import { formattedDate, getAge, swalError } from '@/helper';
import { get_user } from '@/services/user';
import { onMounted, ref } from 'vue';

const props = defineProps({
  child: {
    type: Object
  }
})

const userData =  ref({attributes:{}})
onMounted(async ()=>{
  if (props.child){
    userData.value.id = props.child.relationships.user.data.id
    await get_user_data()
  }
})

async function get_user_data(){
  let response = await get_user(userData.value.id)
  if (response.error){
    swalError(response.message)
    return
  }
  userData.value.attributes = response.data.data.attributes
}

</script>

<template>
  <div class="card">
    <div class="card-header card-no-border">
      <h5 class="m-0">Parent Information</h5>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <p class="info-highlight">
          Father Name: 
          <span>{{ child.attributes?.father_name }}</span>
        </p>
        <p class="info-highlight">
          Contact Number: 
          <a :href="'https://wa.me/' + child.attributes?.father_contact">
            <span class="text-primary">{{ child.attributes?.father_contact }}</span>
          </a>
        </p>
        <p class="info-highlight">
          Mother Name: 
          <span>{{ child.attributes?.mother_name }}</span>
        </p>
        <p class="info-highlight">
          Contact Number: 
          <a :href="'https://wa.me/' + child.attributes?.mother_contact">
            <span class="text-primary">{{ child.attributes?.mother_contact }}</span>
          </a>
        </p>
      </div>
      <div class="row">
        <a class="btn btn-light-primary" :href="'mailto:'+userData.attributes?.email">
          Send Mail
        </a>
      </div>
      
    </div>
  </div>
</template>